import { Button, Checkbox, FormControl, MenuItem, Select, TextField, Typography } from "@mui/material";
import { makeShortLabel, POOptionItem } from "./Extras";
import { convertFractionToDecimal } from "../../helpers/maths";
import { contextFormat, formatCurrency, maybeFormatCurrency } from "../../helpers/strings";
import { useEffect, useState } from "react";
import Loading from "../../components/Loading";

const PurchaseOrderContentField = ({hasErrors, readOnly, current_value, default_value, onClick=null, options=null, field, controlVariant="outlined", controlSize="normal", elementWidth=120, onChange}) => {
    const [value, setValue] = useState(null);
    useEffect(() => {
        if(value === null || value !== current_value) {
          if(current_value === null) {
            setValue(default_value);
          } else {
            setValue(current_value);
          }
        }
    }, [value, default_value, current_value])

    if(value === null) {
      return <Loading />;
    }

    const hiddenLabel = controlSize === "small";
    if(field.type === "choice") {
      return <FormControl
        fullWidth
        error={hasErrors}>
        <Select
          variant={controlVariant}
          size={controlSize}
          sx={{
            borderRadius: 0.5,
            minWidth: elementWidth - 4,
            maxWidth: 400,
            backgroundColor: "#ffffff",
          }}
          readOnly={readOnly}
          displayEmpty={true}
          renderValue={(value) => {
            if(value !== "") {
              return <Typography>{value}</Typography>;
            } else {
              return <Typography sx={{color: "#bbbbbb"}}>{default_value}</Typography>;
            }
          }}
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
            setValue(e.target.value);
          }}
          required={!field.nullable}
        >
          {options.map(
            (option, idx) => (
              <MenuItem key={option.value} value={option.value}>
                <POOptionItem field={field} option={option} />
              </MenuItem>
            )
          )}
          <MenuItem key="null" value={null} hidden={true}></MenuItem>
        </Select>
      </FormControl>;
    }
    if(field.type === "total") {
      return <Typography sx={{ paddingLeft: 2, alignSelf: "center", minHeight: "20px"}} variant="h3">
        {formatCurrency(current_value)}
      </Typography>
    }
    if(field.type === "auto") {
      return <Typography sx={{ paddingLeft: 2, alignSelf: "center", minHeight: "20px" }} variant="h3">
        {maybeFormatCurrency(field.key, current_value)}
      </Typography>
    }
    if(field.type === "title") {
        return <Typography
            key={field.key}
            variant={field.label_type || "h1"}
            sx={{ paddingTop: 2 }}
        >
        {field.label}
        </Typography>
    }
    if(field.type === "info") {
        return <Typography key={field.key} variant="p">
        {field.label}
      </Typography>
    }
    if(field.type === "button") {
        return <Button
        key={field.key}
        sx={{ maxWidth: elementWidth }}
        variant={field.key === "submit_button" ? "contained" : "outlined"}
        color="primary"
        onClick={onClick}
      >
        {field.label}
      </Button>
    }
    let fraction = field.key.includes("width") || field.key.includes("height") || field.key.includes("depth");
    return <TextField
        variant={controlVariant}
        size={controlSize}
        hiddenLabel={hiddenLabel}
        error={hasErrors}
        InputProps={{
          sx: {
            borderRadius: 0.5,
            width: elementWidth - 4,
            backgroundColor: "#ffffff",
          },
          readOnly: field.type === "auto" || readOnly,
        }}
        placeholder={ contextFormat(default_value, field.key) || makeShortLabel(field.label)}
        type={"text"}
        value={value}
        onBlur={() => {
          if(fraction) {
            let val = convertFractionToDecimal(current_value);
            if(val !== 0.0) {
              if(`${val}` !== current_value) {
                onChange(`${val}`);
                setValue(`${val}`);
              }
            }
          }
        }}
        onKeyDown={(e) => {
          if(fraction) {
              if(e.key === 'Enter') {
                let val = convertFractionToDecimal(e.target.value);
                if(val !== 0.0) {
                    onChange(`${val}`);
                    setValue(`${val}`);
                }
              }
          }
        }}
        onChange={(e) => {
          onChange(e.target.value);
          setValue(e.target.value);
        }}
        required={!field.nullable}
    />
}

export { PurchaseOrderContentField }